import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../images/logo-primary.png'


const _withScopeId = n => (_pushScopeId("data-v-637e7d3e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "collected-items" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "img-logo",
  src: _imports_0
}, null, -1))
const _hoisted_3 = { class: "page-title" }
const _hoisted_4 = { class: "box-carousel d-none d-md-block" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "d-block d-md-none" }
const _hoisted_7 = ["src"]

import Carousel from './carousel.vue';
  import { useI18n } from 'vue-i18n';
  import RichText from '../richtext.vue';

  type TItem = {
    image: string;
    name: string;
  }

  interface IProps {
    items: TItem[]
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    items: { default: () => [] }
  },
  setup(__props: any) {

  const { t } = useI18n();
  


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("h4", _hoisted_3, _toDisplayString(_unref(t)('collection_items_title')), 1),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(Carousel, { items: __props.items }, {
        default: _withCtx(({ group, groupIndex }) => [
          _createElementVNode("div", {
            class: _normalizeClass(["box-list", { indexFlex: groupIndex === 0 }])
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: index,
                class: "item"
              }, [
                _createElementVNode("img", {
                  src: item.image
                }, null, 8, _hoisted_5),
                _createVNode(RichText, {
                  class: "name",
                  content: item.name
                }, null, 8, ["content"])
              ]))
            }), 128))
          ], 2)
        ]),
        _: 1
      }, 8, ["items"])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", {
        class: _normalizeClass(["box-list", { indexFlex: __props.items.length < 3 }])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "item"
          }, [
            _createElementVNode("img", {
              src: item.image
            }, null, 8, _hoisted_7),
            _createVNode(RichText, {
              class: "name",
              content: item.name
            }, null, 8, ["content"])
          ]))
        }), 128))
      ], 2)
    ])
  ]))
}
}

})